<ng-template #designHeader>
    <strong class="mr-auto">
      <span class="fa-solid fa-eye mr-2"></span>
      <span translate>Design Preview (<span [innerText]="organizationName" ></span>)</span>
    </strong>
</ng-template>

<ng-template let-toast="toast" #design>
    <div class="pb-2" translate>You can click through the portal to test your new color variables.</div>
    <div class="toast-footer">
      <div class="btn btn-sm btn-outline-primary" aria-hidden="true" (click)="handleResetAction(toast)">Discard changes</div>
      <div class="btn btn-sm btn-primary mr-2" aria-selected="true" aria-hidden="true" (click)="handleApplyAction(toast)">Apply design</div>
    </div>
</ng-template>